import request from "@/utils/request";

export default function payDeviceAnnualFeeByBalance(data) {
  return request({
    url: `/device/agent/chargingPile/payDeviceAnnualFeeByBalance`,
    method: "post",
    data,
  });
}
